var _circle, _rect, _rect2, _rect3, _rect4, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataAnalyticsEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 243,
    viewBox: "0 0 243 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.5,
    cy: 121.5,
    r: 121.5,
    fill: "#F3FAFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 125,
    width: 32,
    height: 84,
    rx: 4,
    fill: "#1778E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 96,
    width: 31,
    height: 113,
    rx: 4,
    fill: "#1778E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 136,
    width: 32,
    height: 73,
    rx: 4,
    fill: "#1778E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: 33,
    width: 44,
    height: 38,
    rx: 5,
    fill: "#ADCCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.804 59.097C119.936 59.069 119.145 58.985 118.431 58.845C117.717 58.705 117.094 58.516 116.562 58.278V55.926C117.094 56.178 117.752 56.409 118.536 56.619C119.32 56.829 120.076 56.948 120.804 56.976V53.406C119.782 53.042 118.956 52.678 118.326 52.314C117.71 51.936 117.255 51.509 116.961 51.033C116.681 50.543 116.541 49.962 116.541 49.29C116.541 48.24 116.933 47.414 117.717 46.812C118.501 46.196 119.53 45.839 120.804 45.741V44.061H122.19V45.699C122.96 45.727 123.674 45.818 124.332 45.972C124.99 46.126 125.62 46.329 126.222 46.581L125.403 48.66C124.885 48.45 124.346 48.282 123.786 48.156C123.24 48.016 122.708 47.925 122.19 47.883V51.369C123.002 51.635 123.737 51.929 124.395 52.251C125.053 52.573 125.578 52.979 125.97 53.469C126.362 53.945 126.558 54.568 126.558 55.338C126.558 56.346 126.187 57.179 125.445 57.837C124.717 58.495 123.632 58.894 122.19 59.034V61.218H120.804V59.097ZM120.804 47.925C119.698 48.051 119.145 48.485 119.145 49.227C119.145 49.619 119.271 49.934 119.523 50.172C119.775 50.41 120.202 50.634 120.804 50.844V47.925ZM122.19 56.892C123.366 56.738 123.954 56.269 123.954 55.485C123.954 55.107 123.814 54.806 123.534 54.582C123.268 54.344 122.82 54.12 122.19 53.91V56.892Z",
    fill: "#1778E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 76L126.696 70H116.304L121.5 76Z",
    fill: "#ADCCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5002 177.499L71.8299 179.383L73.114 179.84L74.0088 178.812L72.5002 177.499ZM121 121.776L122.234 120.202L120.739 119.03L119.492 120.463L121 121.776ZM168.5 158.999L167.266 160.573L168.409 161.468L169.614 160.66L168.5 158.999ZM225.962 122.164C226.176 121.081 225.471 120.029 224.387 119.815L206.727 116.334C205.643 116.12 204.591 116.825 204.378 117.909C204.164 118.993 204.869 120.045 205.953 120.258L221.651 123.353L218.556 139.051C218.343 140.135 219.048 141.186 220.132 141.4C221.215 141.614 222.267 140.908 222.481 139.824L225.962 122.164ZM19.8297 160.885L71.8299 179.383L73.1705 175.614L21.1703 157.116L19.8297 160.885ZM74.0088 178.812L122.509 123.089L119.492 120.463L70.9916 176.186L74.0088 178.812ZM119.767 123.35L167.266 160.573L169.734 157.424L122.234 120.202L119.767 123.35ZM169.614 160.66L225.114 123.439L222.886 120.117L167.386 157.338L169.614 160.66Z",
    fill: "#ADCCFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalyticsEmptyState);
export default __webpack_public_path__ + "static/media/data-analytics-empty-state.c9364821.svg";
export { ForwardRef as ReactComponent };